import { Button, Modal } from 'antd';
import InfoModal from 'components/InfoModal';
import { I18nt } from 'utils';
import { ModalContent } from 'utils/interfaces';
import { useExamenesLabCtx } from '../ExamenesLabContext';
import styles from './ExamenesLab.module.less';

export function FormResponseModal() {
	const { statusMessage, resetState } = useExamenesLabCtx();

	const modalContent: ModalContent = {
		'el-1': {
			title: 'numero_de_afiliado_no_encontrado',
			body: 'el_numero_que_ingresaste',
		},
		'el-2': {
			title: 'numero_afiliado_inactivo',
			body: 'para_poder_consultar',
		},
		'el-4': {
			title: 'datos_no_coinciden',
			body: 'su_fecha_de_nacimiento',
		},
	};

	if (!statusMessage) {
		return null;
	}
	const message = modalContent[statusMessage];
	if (!message) {
		return null;
	}

	return (
		<InfoModal
			onOk={typeof message.action === 'function' ? message.action : resetState}
			okText={message.buttonText}
			body={message.body}
			title={message.title}
			dynamicText={message.dynamicText}
			visible={Boolean(statusMessage)}
		/>
	);
}

export function ConsultaConTuMedicoModal() {
	const { dispatch, showConsultaTuMedicoModal } = useExamenesLabCtx();
	return (
		<InfoModal
			visible={showConsultaTuMedicoModal}
			title='consulta_a_tu_medico'
			body='los_resultados_de_este_tipo'
			okText='de_acuerdo'
			onOk={() => dispatch({ type: 'showConsultaTuMedico', payload: false })}
		/>
	);
}

export function ResultadoModal() {
	const { dispatch, showResultadoModal, resultado } = useExamenesLabCtx();

	const formatResult = (result: string) => {
		let formatted = '';
		const resultsList = result.split('\n');
		if (resultsList.length > 1) {
			resultsList.forEach((str) => (formatted += `<li>${str}</li>`));
			return `<ul>${formatted}</ul>`;
		}
		return result;
	};

	const footer = (
		<footer>
			<Button
				onClick={() => dispatch({ type: 'showResultado' })}
				type='primary'
			>
				{I18nt('cerrar')}
			</Button>
		</footer>
	);
	return (
		<Modal
			visible={showResultadoModal}
			title={<h2>{I18nt('resultado')}</h2>}
			footer={footer}
		>
			<div
				className={styles.resultadoModal}
				dangerouslySetInnerHTML={{
					__html: formatResult(resultado?.resultado ?? ''),
				}}
			/>
		</Modal>
	);
}
